import React from "react";
import "../Styles/pdf.scss";
const PdfDocument = ({
  record = {},
  productData = [],

  taxData = [],
}) => {
  const restRows =
    productData.length >= 10 ? 0 : (10 - productData.length) * 20;
  return (
    <div className="body">
      <div className="pdf-container">
        <div className="logo-container">
          <div className="logo_jpg">
            {record.store_details?.store_image ? (
              <img
                src="/images/logo.jpg"
                alt="logo"
              />
            ) : (
              <img src="/images/logo.jpg" alt="logo" />
            )}
          </div>
          <div className="supplier-details">
            <div>
              <strong>{record.store_details?.store_name}</strong>{" "}
              <p>
                {record.store_details?.store_city +
                  ", " +
                  record.store_details?.store_ward +
                  ", " +
                  record.store_details?.store_state}
              </p>
              <p>{record.store_details?.store_email}</p>
              <p>{record.store_details?.store_phone}</p>
            </div>
          </div>
        </div>
        <div className="pdfheader">{record.order_type}</div>
        <div className="section">
          <div>
            <section>
              <strong>Invoice From</strong>
            </section>
            <p>
              Name: <b>{record.store_details?.store_name}</b>
            </p>
            <p>
              Email: <b>{record.store_details?.store_email}</b>
            </p>
            <p>Tel: {record.store_details?.store_phone}</p>
          </div>
          <div>
            <section>
              <strong>Invoice To</strong>
            </section>
            <p>
              Name:{" "}
              <b>
                {record.customer?.cust_first_name +
                  " " +
                  record.customer?.cust_last_name}
              </b>
            </p>
            <p>
              Email: <b>{record.customer?.cust_email}</b>
            </p>
            <p>Tel: {record.customer?.cust_phone}</p>
          </div>
          <div className="invoice">
            <div className="invoice_div">
              <p>Order No:</p>
              <p className="invoice_box">{record.order_no}</p>
            </div>
            <div className="invoice_div">
              <p>Due Date:</p>
              <p className="invoice_box">
                {new Date(record.created_date).toLocaleDateString()}
              </p>
            </div>
            <div className="invoice_div">
              <p>Terms:</p>
              <p className="invoice_box">{record.payment_status}</p>
            </div>
            <div className="invoice_div">
              <p>Amount Due:</p>
              <p className="invoice_box">{record.total_amount}</p>
            </div>
          </div>
        </div>
        

        <div className="table-border">
          <table className="table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Item Code</th>
                <th>Item Name</th>
                <th>Qty</th>
                <th>Rate</th>
                <th>Taxable Amt</th>
                <th>Tax Amt</th>
                <th>Total Amt</th>
              </tr>
            </thead>
            <tbody>
              {productData.map((item, index) => {
                return (
                  <tr>
                    <td>{item.sn}</td>
                    <td>{item.itemCode}</td>
                    <td>{item.itemName}</td>
                    <td>{item.qty}</td>
                    <td>{item.rate}</td>
                    <td>{item.taxableAmt}</td>
                    <td>{item.taxAmt}</td>
                    <td>{item.totalAmt}</td>
                  </tr>
                );
              })}
              <tr>
                <td style={{ height: restRows }}></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="footer">
          <div className="signature-section">
            <div className="w-65">
              <p className="mb-5 font-bold text-left">TAX SUMMARY</p>
              <table className="tax-summary">
                <thead>
                  <tr>
                    <th>Tax Rate</th>
                    <th>Taxable Amt</th>
                    <th>Tax Amt</th>
                    <th>Total Amt</th>
                  </tr>
                </thead>
                <tbody>
                  {taxData.map((row) => {
                    return (
                      <tr>
                        <td className="font-bold">{row.taxRate}</td>
                        <td>{row.taxableAmt}</td>
                        <td> {row.taxAmt}</td>
                        <td>{row.totalAmt}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="powered-by">
          <div className="logo_jpg">
            <img src="/images/logo.jpg" alt="logo" />
          </div>
          This Receipt was generated with the help of Ocelot Links POS. <br />{" "}
          Learn more and create your own free trial account by visiting
          ocelotlinks.com or call 0711664444 for assistance.
          <br />
          <strong>Powered by Ocelot Technologies Ltd</strong>
        </div>
      </div>
    </div>
  );
};

export default PdfDocument;
